module.exports = __webpack_public_path__ + "static/media/frame1.37d705d7.png";